import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import styles from './FuelTransactionDrawerBody.styles';
import TabLayout from '../shared/TabLayout';
import FuelTransactionType from '../shared/FuelTransactionType';
import { selectSelectedFuelTransaction } from '../../redux/store/userData/fuelTransactions';
import FuelTransactionInfo from './FuelTransactionInfo';
import FuelTransactionItems from './FuelTransactionItems';
import FuelTransactionTimeline from './FuelTransactionTimeline';
import FuelTransactionMap, {
  hasFuelTransactionLocations,
} from './FuelTransactionMap';

const FuelTransactionDrawerBody = () => {
  const intl = useIntl();
  const selectedFuelTransaction = useSelector(selectSelectedFuelTransaction);
  const uniqueId = selectedFuelTransaction?.uniqueId || '';

  const tabs = [
    {
      title: intl.formatMessage({
        id: 'fleetadmin.fuelTransactions.tab.info',
        defaultMessage: 'Info',
      }),
      content: <FuelTransactionInfo />,
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.fuelTransactions.tab.items',
        defaultMessage: 'Items',
      }),
      content: <FuelTransactionItems />,
    },
    ...(selectedFuelTransaction?.type === 'ryd'
      ? [
          {
            title: intl.formatMessage({
              id: 'fleetadmin.fuelTransactions.tab.timeline',
              defaultMessage: 'Timeline',
            }),
            content: <FuelTransactionTimeline />,
          },
        ]
      : []),
    ...(hasFuelTransactionLocations(selectedFuelTransaction)
      ? [
          {
            title: intl.formatMessage({
              id: 'fleetadmin.fuelTransactions.tab.map',
              defaultMessage: 'Map',
            }),
            content: <FuelTransactionMap />,
          },
        ]
      : []),
  ];

  return (
    <>
      <div className="fuel-transaction-drawer-body">
        <div className="fuel-transaction-name-wrapper">
          <p className="name" title={uniqueId}>
            {uniqueId.length > 20 ? `${uniqueId.slice(0, 20)}...` : uniqueId}
          </p>
        </div>
        <TabLayout tabs={tabs} keyName="fuel-transaction-drawer" />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FuelTransactionDrawerBody;
